import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=5044b710&scoped=true&"
import script from "./EditCoupon.vue?vue&type=script&lang=js&"
export * from "./EditCoupon.vue?vue&type=script&lang=js&"
import style0 from "./EditCoupon.vue?vue&type=style&index=0&id=5044b710&lang=scss&scoped=true&"
import style1 from "./EditCoupon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044b710",
  null
  
)

export default component.exports